import {
  TERRITORY_SUCCESS,
  TERRITORY_PENDING,
  TERRITORY_FAIL,
  ADD_TERRITORY_SUCCESS,
  ADD_TERRITORY_PENDING,
  ADD_TERRITORY_FAIL,
  UPDATE_TERRITORY_SUCCESS,
  UPDATE_TERRITORY_PENDING,
  UPDATE_TERRITORY_FAIL,
} from "../../actions/types";

const initialState = {
  territories: [],
  addTerritory: "",
  updateTerritory: "",
  isTerritoryLoading: false,
};

const territory_reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TERRITORY_SUCCESS:
      return {
        ...state,
        territories: payload.territories,
        isTerritoryLoading: false,
      };
    case TERRITORY_PENDING:
      return {
        ...state,
        territories: payload.territories,
        isTerritoryLoading: true,
      };
    case TERRITORY_FAIL:
      return {
        ...state,
        territories: [],
        isTerritoryLoading: false,
      };
    case ADD_TERRITORY_SUCCESS:
      return { ...state, addTerritory: payload.addTerritory };
    case ADD_TERRITORY_PENDING:
      return { ...state, addTerritory: payload.addTerritory };
    case ADD_TERRITORY_FAIL:
      return { ...state, addTerritory: false };
    case UPDATE_TERRITORY_SUCCESS:
      return { ...state, updateTerritory: payload.updateTerritory };
    case UPDATE_TERRITORY_PENDING:
      return { ...state, updateTerritory: payload.updateTerritory };
    case UPDATE_TERRITORY_FAIL:
      return { ...state, updateTerritory: false };
    default:
      return state;
  }
};

export default territory_reducer;
